import { Shield, Mail } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 md:px-10 md:py-16">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Legal</p>
      <h1 className="mt-2 font-display text-4xl font-medium tracking-tight">Privacy Policy</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: 4 June 2026</p>
      <div className="prose prose-invert mt-8 max-w-none text-sm leading-relaxed text-foreground/90">
        <p><Shield className="mr-1 inline h-4 w-4 text-primary" /> Your data is encrypted in transit (HTTPS/TLS) and at rest. We do not sell your data. Ever.</p>

        <h2 className="mt-6 font-display text-xl">What we collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account info (name, email, hashed password)</li>
          <li>Profile preferences (country, currency, language)</li>
          <li>Wallet activity (balances, transactions, bank details — encrypted)</li>
          <li>Chats with AI assistants (used to provide replies, never sold)</li>
          <li>Anonymous analytics (Google Tag Manager) — opt-out via browser settings</li>
        </ul>

        <h2 className="mt-6 font-display text-xl">How we use it</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Operate Zuntria features (chat, wallet, Ajo, marketplace, documents)</li>
          <li>Process payments via Stripe (we never store your card)</li>
          <li>Notify you about contributions, payouts, and account activity</li>
          <li>Detect fraud and prevent abuse</li>
        </ul>

        <h2 className="mt-6 font-display text-xl">Payments &amp; Stripe</h2>
        <p>Payments are handled by Stripe, a PCI-DSS Level 1 certified processor. We never see or store your card details. Bank details for withdrawals are stored encrypted and only used to send your funds.</p>

        <h2 className="mt-6 font-display text-xl">Your rights</h2>
        <p>You can request data export or deletion any time by emailing <a className="text-primary underline" href="mailto:support@zuntria.ai">support@zuntria.ai</a>. We respond within 7 days.</p>

        <h2 className="mt-6 font-display text-xl">Contact</h2>
        <p><Mail className="mr-1 inline h-4 w-4 text-primary" /> <a className="text-primary underline" href="mailto:support@zuntria.ai">support@zuntria.ai</a></p>
      </div>
    </div>
  );
}
